import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  public static readonly vgSessionEndpoint = 'internalSession'

  constructor(private readonly http: HttpClient) {}

  isInternalSession() {
    return this.http.get(`vmf/api/`.concat(CookieService.vgSessionEndpoint), {
      responseType: 'text',
      withCredentials: true,
    })
  }
}
